var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPresenceAvailableOther(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.59,17.26c-2.83,0-5.11-2.6-5.11-5.74a5.25,5.25,0,0,1,5-5.52h.15a5.26,5.26,0,0,1,5.13,5.38h0v.13C20.71,14.69,18.41,17.26,15.59,17.26Z",
    style: {
      fill: "#6bae44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.12,25.77V20.35a4.07,4.07,0,0,1-1.29-.67,5.21,5.21,0,0,0-1.17-1,2,2,0,0,0-2.46.4,18.87,18.87,0,0,0-2.6,3.95L6.15,24c-.18.38-.36,1.06-.1,1.39a2.11,2.11,0,0,0,1.57.55Z",
    style: {
      fill: "#6bae44"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "26.08 21.41 20.84 16.83 20.84 19.45 15.6 19.45 15.6 23.38 20.84 23.38 20.84 26 26.08 21.41",
    style: {
      fill: "#9868b9"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresenceAvailableOther);
export default __webpack_public_path__ + "static/media/presence-available-other.a1312248.svg";
export { ForwardRef as ReactComponent };